import { lazy } from 'react';

const CasinoRoutes = lazy(() =>
	import(
		/* webpackChunkName: "casino-routes" */
		'./casino-routes.js'
	)
);

export default CasinoRoutes;
